module.exports = __webpack_public_path__ + "03_mid_yellow.b22a0802.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_mid_yellow.png
// module id = NifX
// module chunks = 0